import { Authority } from '../../../shared/enums/authority.enum';
import { Status } from '../../../shared/enums/status.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Photo } from '../../../shared/models/photo.model';
import { ShortLink } from '../../../shared/models/shortlink.model';
import { Translation } from '../../../shared/models/translation.model';
import { Store } from '../../store/models/store.model';

export class Place {
	id: number;
	placeUuid: string;
	tradeName: string;
	companyName: string;
	cnpj: string;
	description: string;
	averageRating: number;
	numberReviews: number;
	phone: string;
	status: Status;
	coverImage: Photo;
	logoImage: Photo;
	shortLink: ShortLink;
	authority: Authority;
	uniquePayment: boolean;
	hostname?: string;

	minimumDeliveryPrice: number;
	allowOnlinePayment: boolean;
	allowPayLater: boolean;
	
	contactName: string;
	cpf: string;
	contactEmail: string;
	contactPhone: string;
	establishments: Array<Store>;

	//address
	state: string;
	city: string;
	street: string;
	number: string;
	complement: string;
	neighborhood: string;
	zipCode: string;
	lat?: number;
	lon?: number;

	changeGeolocation: boolean;
	saveIdentity?: boolean;

	// Aux view
	descriptionTranslations: Translation;

	constructor(place: any = { }) {
		Object.assign(this, place);

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, Status);
		}
		if (this.authority != null && this.authority['code'] == null) {
			this.authority = UtilHelper.getEnumByCod(this.authority, Authority);
		}
	}

	getFullFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + this.number;
		}
		if (this.complement) {
			address += ", " + this.complement;
		}
		if (this.neighborhood) {
			address += " - " + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}

	getStreetFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + this.number;
		}
		return address;
	}

	// Ap 2 - Centro, Curitiba - PR
	getComplementFormattedAddress(): string {
		let address: string = "";
		if (this.complement) {
			address += this.complement;
		}
		if (this.neighborhood) {
			address += (address ? " - " : " ") + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/place/models/place.model.ts